globalThis.__VUE_OPTIONS_API__ = true;
globalThis.__VUE_PROD_DEVTOOLS__ = false;

import { createApp } from 'vue/dist/vue.esm-bundler';
import Vue3Odometer from '../../node_modules/vue3-odometer';
// import 'odometer/themes/odometer-theme-default.css'
import counterfield from '../../src/js/components/counterfield.js';

document.addEventListener( 'DOMContentLoaded', () => {
	const mlmCalculator = document.querySelector('#mlm-calculator');
	if (mlmCalculator) {
		// const { createApp } = Vue;
		const app = createApp({
			data() {
				return {
					inited: false,
					currency: '$',

					average_loan_amount: 350000,
					average_loan_amount_formated: 0,
					average_loan_amount_fill: 0,
					average_loan_amount_min: 0,
					average_loan_amount_max: 1500000,

					number_of_agents: 10,
					average_number_of_transactions: 4,
					average_number_recruited: 2,
					compensation: [
						//0.005,
						0.0015,
						0.0007,
						0.0003
					],
				
					calculatedValues: {}
				}
			},
			components: {
				'counterfield': counterfield,
				'vue3odometer': Vue3Odometer
			},
			methods: {
				init() {
					this.inited = true;
					this.update();
					this.calc();
				},
				update() {
					this.average_loan_amount_formated = this.currency + this.formatValue(this.average_loan_amount);
					this.average_loan_amount_fill = this.getPercent(this.average_loan_amount, 0, this.average_loan_amount_max);
				},
				updateOdometerValue(name, value) {
					name = name.split('.');
					if (name.length == 2) {
						this[name[0]][name[1]] = value;
					}
					else if (name.length == 3) {
						this[name[0]][name[1]][name[2]] = value;
					}
					else {
						this[name] = value;
					}
				},
				updateOdometer(name, oldValue, newValue) {
					let newValueLength = String(newValue).length;

					if ( oldValue > newValue && String(oldValue).length != newValueLength) {
						const value = +String(oldValue).slice(0, newValueLength);
	
						this.updateOdometerValue(name, value);
					}
	
					this.$nextTick(() => {
						this.updateOdometerValue(name, newValue);
					})
				},
				calc() {
					let number_of_loans = 0;
					let anticipated_annual_earnings = 0;
					let number_of_agents = this.number_of_agents;
					let total_volume = 0;
					let commissions = 0;

					if (!this.compensation) return false;

					this.compensation.forEach((item, index) => {
						anticipated_annual_earnings += (this.average_loan_amount * this.average_number_of_transactions * number_of_agents * item)
						number_of_loans += (number_of_agents * this.average_number_of_transactions);
						number_of_agents = number_of_agents * this.average_number_recruited;
					});
					anticipated_annual_earnings = Math.ceil(anticipated_annual_earnings);
					number_of_agents = Math.ceil(number_of_agents);
					total_volume = number_of_loans * this.average_loan_amount;
					commissions = ((anticipated_annual_earnings/total_volume) * 100).toFixed(2);
					commissions = isNaN(commissions) ? 0 : commissions

					this.updateOdometer('calculatedValues.anticipated_annual_earnings', this.calculatedValues.anticipated_annual_earnings, anticipated_annual_earnings);
					this.calculatedValues = {
						// anticipated_annual_earnings: anticipated_annual_earnings,
						number_of_loans: number_of_loans,
						total_volume: this.currency + this.formatValue(total_volume),
						commissions: commissions
					}
					
				},
				percentageOff(value, percent) {
					return value - this.percentage(value, percent);
				},
				percentage(value, percent) {
					return Math.ceil(value * (percent / 100));
				},
				formatValue(value) {
					return (+value).toLocaleString();
				},
				numberFormatter(num, digits) {
					digits = digits ? digits : 1;

					const lookup = [
						{ value: 1, symbol: "" },
						{ value: 1e3, symbol: "k" },
						{ value: 1e6, symbol: "M" },
						{ value: 1e9, symbol: "G" },
						{ value: 1e12, symbol: "T" },
						{ value: 1e15, symbol: "P" },
						{ value: 1e18, symbol: "E" }
					];
					const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
					let item = lookup.slice().reverse().find(function(item) {
						return num >= item.value;
					});

					return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
				},
				getPercent: (value, min, max) => {
					return ((value - min) / (max - min)) * 100;
				},
				updateValue(name, value) {
					this[name] = value;
					this.calc();
				}
			},
			
			mounted() {
				let average_loan_amount = this.$el.getAttribute('data-average_loan_amount')
				if (average_loan_amount && +average_loan_amount >= 0) {
					this.average_loan_amount = +average_loan_amount;
				}
				let number_of_agents = this.$el.getAttribute('data-number_of_agents')
				if (number_of_agents && +number_of_agents >= 0) {
					this.number_of_agents = +number_of_agents;
				}
				let average_number_of_transactions = this.$el.getAttribute('data-average_number_of_transactions')
				if (average_number_of_transactions && +average_number_of_transactions >= 0) {
					this.average_number_of_transactions = +average_number_of_transactions;
				}
				let average_number_recruited = this.$el.getAttribute('data-average_number_recruited')
				if (average_number_recruited && +average_number_recruited >= 0) {
					this.average_number_recruited = +average_number_recruited;
				}
				this.init();
			}
		}).mount(mlmCalculator)
	}
} )
